module.exports = function htmx() {
    return (req, res, next) => {
        req.htmx = req.headers['hx-request'] === 'true';

        res.hxTrigger = (event) => res.setHeader('HX-Trigger', event);
        res.hxRedirect = (url) => {
            res.setHeader('HX-Redirect', url);
            res.writeHead(200);
            res.end();
        };
        res.hxRefresh = () => {
            res.setHeader('HX-Refresh', 'true');
            res.writeHead(200);
            res.end();
        };
        res.hxLocation = (url) => res.setHeader('HX-Location', url);
        res.hxPushUrl = (url) => res.setHeader('HX-Push-Url', url);
        res.hxReplaceUrl = (url) => res.setHeader('HX-Replace-Url', url);
        res.hxReswap = (swapType) => res.setHeader('HX-Reswap', swapType);
        res.hxRetarget = (target) => res.setHeader('HX-Retarget', target);

        next();
    };
};
